import { useEffect } from 'react';
import type { UserThemePreference } from '@/services/supabase';
import {
  initThemeSystemListener,
  useThemeStore,
} from '@/stores/useThemeStore';
import {
  isDarkTheme,
  type ThemeId,
} from '@/theme/themes';

function themeIdToPreference(id: ThemeId): UserThemePreference {
  if (id === 'light') return 'light';
  if (isDarkTheme(id)) return 'dark';
  return 'default';
}

export const useDarkMode = () => {
  const { resolvedThemeId, themePreference, setThemePreference } = useThemeStore();

  useEffect(() => {
    initThemeSystemListener();
  }, []);

  const setTheme = (id: ThemeId) => {
    setThemePreference(themeIdToPreference(id));
  };

  const isDarkMode = isDarkTheme(resolvedThemeId);

  const toggleTheme = () => {
    setThemePreference(isDarkMode ? 'light' : 'dark');
  };

  return {
    themeId: resolvedThemeId,
    themePreference,
    setTheme,
    setThemePreference,
    isDarkMode,
    toggleTheme,
  };
};
